import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "text-truncate",
  style: {"max-width":"80px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("td", _hoisted_1, _toDisplayString(_ctx.specialTruncate(_ctx.object.Stats[_ctx.statTypeEnum.Value].Data)), 1))
}